import { Flex } from '@chakra-ui/react';
import { useReviewCreationData } from 'reducers/reviewCreationSlice';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { Accordion } from 'uiToolkitV1/Accordion';
import { AccordionButton, AccordionItem2, AccordionPanel2 } from 'uiToolkitV1/Accordion/Accordion';
import { TextHeader4 } from 'uiToolkitV1/Typography';

import { useTemplateMetadata } from '../../../Hooks/dataHooks/shareResultsDataHooks';
import { PreviewFormButton } from '../../FormFillingExperience/PreviewFormButton';
import { AnonymousSettings } from './AnonymousSettings';
import { ManagerScoreVisibility } from './ManagerScoreVisibility';
import { ReviewerTypeVisibilitySettings } from './ReviewerTypeVisibilitySettings';
import { ScoreVisibilitySettings } from './ScoreVisibilitySettings';

export const SelfReviewerSettings = ({ feedbackFormId }) => {
  const { reviewCycleId } = useReviewCreationData();

  const selfTemplateMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.SELF,
  });

  const templateHasQuestions = selfTemplateMetadata?.template?.questionCount > 0;

  return (
    <Accordion defaultIndex={0} allowMultiple allowToggle boxShadow="none !important">
      <AccordionItem2 sxProps={{ borderBottom: 'none !important' }}>
        <AccordionButton>
          <Flex justifyContent="space-between" alignItems="center" flexGrow={1}>
            <TextHeader4 bold>Self reviewer</TextHeader4>
            <PreviewFormButton
              feedbackFormId={feedbackFormId}
              providerType={REVIEW_PROVIDER_TYPES.SELF}
              isDisabled={!templateHasQuestions}
              label="Preview report card for Self"
              isShareResultPage
            />
          </Flex>
        </AccordionButton>

        <AccordionPanel2 pl="32px !important" mb="10px">
          <Flex flexDirection="column" gap={7}>
            <ManagerScoreVisibility feedbackFormId={feedbackFormId} />
            <ReviewerTypeVisibilitySettings feedbackFormId={feedbackFormId} />
            <ScoreVisibilitySettings feedbackFormId={feedbackFormId} />
            <AnonymousSettings feedbackFormId={feedbackFormId} />
          </Flex>
        </AccordionPanel2>
      </AccordionItem2>
    </Accordion>
  );
};
